export const bgParallax = () => {
    document.addEventListener('DOMContentLoaded', () => {
        if (!document.querySelector('[data-rellax-speed]')) return;
        new Rellax('[data-rellax-speed]');
    });
};
